import { useMutation } from "@tanstack/react-query";
import { superAdminControllerMigrateVectorDatabaseMetadata } from "../lib/gen-api";

/**
 * @deprecated - use once
 */
export const useMigrateVectorDatabaseMetadata = () => {
  const { mutateAsync: migrateVectorDatabaseMetadata, isPending } = useMutation(
    {
      mutationFn: async () => {
        const result =
          await superAdminControllerMigrateVectorDatabaseMetadata();
        if (!result.response.ok || !result.data) {
          throw new Error("Failed to migrate vector database metadata");
        }
        return result.data;
      },
    },
  );

  return { migrateVectorDatabaseMetadata, isPending };
};
